import { useIntl } from 'react-intl'
import clsx from 'clsx'
import { rem } from 'polished'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import PriceRowLuxPlusNonMemberPrice from 'LuxKit/PricePoints/LuxPlus/PriceRowLuxPlusNonMemberPrice'
import PriceRowLuxPlusPrice from 'LuxKit/PricePoints/LuxPlus/PriceRowLuxPlusPrice'
import Caption from 'LuxKit/Typography/Caption'
import { mediaQueryUp } from 'components/utils/breakpoint'
import PriceRowValueDiscountWithCaption from 'LuxKit/PricePoints/Value/PriceRowValueDiscountWithCaption'

const FadingElement = styled.div`
  display: none;
  min-width: ${rem(120)};

  &.visible {
    display: block;
  }

  ${mediaQueryUp.tablet} {
    display: block;
    opacity: 0;
    transition: opacity 0.2s;
    pointer-events: none;

    &.visible {
      display: block;
      opacity: 1;
      pointer-events: auto;
    }
  }
`

interface Props {
  totalPrice: number
  totalMemberPrice?: number
  totalGrossPrice?: number
  isFromPrice: boolean
  ticketUnitLabel: string
  discountPercentage?: number
  discountMemberPercentage?: number
  isLuxPlusOffer: boolean
}

function ExperienceBookingModalPrices(props: Props) {
  const {
    totalPrice,
    totalMemberPrice,
    totalGrossPrice,
    isFromPrice,
    ticketUnitLabel,
    discountPercentage,
    discountMemberPercentage,
    isLuxPlusOffer,
  } = props
  const intl = useIntl()

  const fromLabel = intl.formatMessage({
    id: 'xluI1eimxC5IEgqYsjlQ',
    defaultMessage: 'From',
    description: 'Price caption prefix in experience booking modal prices',
  })
  const totalLabel = intl.formatMessage({
    id: 'fD59EMxbAJtJaQpX53BN',
    defaultMessage: 'total',
    description: 'Sale unit label for total price in experience booking modal prices',
  })

  if (isLuxPlusOffer && totalMemberPrice) {
    return (
      <Group direction="vertical" gap={0}>
        <FadingElement as={Caption} className={clsx({ visible: isFromPrice })} variant="medium" colour="light-foreground-alt">
          {fromLabel}
        </FadingElement>
        <PriceRowLuxPlusPrice
          logoPlacement="trailing"
          size="L"
          memberPrice={totalMemberPrice}
          saleUnit={isFromPrice ? ticketUnitLabel : totalLabel}
          discountType="estimate"
        />
        {!totalGrossPrice && (<PriceRowLuxPlusNonMemberPrice
          nonMemberPrice={totalPrice}
        />)}
        {totalGrossPrice && <PriceRowValueDiscountWithCaption
          originalValue={totalGrossPrice}
          size="M"
          discountPercentage={discountMemberPercentage}
          discountType={isFromPrice ? 'estimate' : 'exact'}
        />}
      </Group>
    )
  }

  if (!totalPrice) return null

  return (
    <>
      <FadingElement as={Caption} className={clsx({ visible: isFromPrice })} variant="medium" colour="light-foreground-alt">
        {fromLabel}
      </FadingElement>
      <PriceRowPrice
        size="L"
        price={totalPrice}
        saleUnit={isFromPrice ? ticketUnitLabel : totalLabel}
        discountPercentage={discountPercentage}
        discountType="estimate"
      />
    </>
  )
}

export default ExperienceBookingModalPrices
